import React from 'react';
import PropTypes from 'prop-types';
import {
  ChipV2,
  Spacer,
  Visible,
  Tooltip,
} from '@tfecom-thermofisher/react-komodo-design';

import { Message, Title } from 'src/core/components';
import MoreInfo from 'src/components/MoreInfo';

import './DataSelector.style.scss';

const DataSelectorComponent = ({
  title,
  config,
  selectedValue,
  moreInfoLink,
  onSelect,
}) => (
  <>
    <Title message={title} size="5" />
    <Spacer bottom="8" />
    <div className="dna-chips">
      {config.map(({ value, label, disabled, tooltipMessage }) => {
        const chip = (
          <ChipV2
            {...{
              key: value,
              id: title?.id,
              label: label?.id ? <Message message={label} /> : label,
              selected: value === selectedValue,
              onClick: () => {
                if (disabled) {
                  return;
                }

                onSelect(value);
              },
              disabled
            }}
          />
        );

        if (tooltipMessage?.id) {
          return (
            <span key={value}>
              <Tooltip
                tooltipContent={(
                  <div className="dna-template-details__tooltip">
                    <Message message={tooltipMessage} />
                  </div>
                )}
                placement="top"
                trigger="mouseenter"
              >
                <div>
                  {chip}
                </div>
              </Tooltip>
              <Spacer right={5} />
            </span>
          );
        }

        return chip;
      })}
    </div>
    <Visible when={moreInfoLink}>
      <MoreInfo link={moreInfoLink} />
    </Visible>
    <Spacer bottom={32} />
  </>
);

DataSelectorComponent.propTypes = {
  title: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string.isRequired,
  }),
  config: PropTypes.array.isRequired,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  moreInfoLink: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

export default DataSelectorComponent;
